/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const StepForward = [
  [
    "path",
    { d: "M10.029 4.285A2 2 0 0 0 7 6v12a2 2 0 0 0 3.029 1.715l9.997-5.998a2 2 0 0 0 .003-3.432z" }
  ],
  ["path", { d: "M3 4v16" }]
];

export { StepForward as default };
//# sourceMappingURL=step-forward.js.map
